<template>
  <div class="c-steps-carousel">
    <sc-text tag="h3" v-if="fields && fields.heading" :field="fields.heading" />

    <template v-if="isEditing">
      <!--
          When experience editor is active we want to render all carousel slides, to simplify editing.
        -->
      <sc-placeholder name="jss-steps-carousel" :rendering="rendering" />
    </template>
    <template v-else>
      <Splide v-if="hasStepsPlaceholder" :options="options" aria-label="Steps">
        <SplideSlide
          v-for="(step, index) in $options.computed.stepsPlaceholder"
          :is="step"
          :key="`step${index}`"
        >
          <component :is="step" :key="`step${index}`" />
        </SplideSlide>
      </Splide>
    </template>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css/core';

export default {
  name: 'CIS-Steps-Carousel',
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder,
    Splide,
    SplideSlide
  },
  props: {
    rendering: {
      type: Object
    },
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  withPlaceholder() {
    return {
      placeholders: [
        {
          placeholder: 'jss-steps-carousel',
          computedPropName: 'stepsPlaceholder'
        }
      ]
    };
  },
  setup() {
    const options = {
      type: 'fade',
      arrows: false,
      autoplay: false
    };

    return { options };
  },
  computed: {
    isEditing() {
      const instance = getCurrentInstance();

      return !!instance?.appContext?.config?.globalProperties?.$jss?.sitecoreContext()?.pageEditing;
    },
    hasStepsPlaceholder() {
      return this.$options?.computed?.stepsPlaceholder?.length > 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.c-steps-carousel {
  border-radius: 5px;
  background-color: $dark-blue;
  padding: 2rem 2.8rem 1.4rem 2.8rem;
  margin-bottom: 4rem;

  @include desktop-up {
    padding: 3.2rem 3.2rem 1.4rem 3.2rem;
    margin-bottom: 0;
  }

  h3 {
    @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $white);
    text-align: center;
    margin: 0 0 1.6rem 0;

    @include desktop-up {
      @include font-styles('Arial', 2.8rem, 200, normal, 3.5rem, 0, $white);
      text-align: left;
      margin: 0;
    }
  }
}
</style>
